import PropTypes from "prop-types";

export const UnitSelectComponentPropTypes = {
  unitType: PropTypes.string,
  unitValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setUnitHandler: PropTypes.func,
};
